<app-header *ngIf="isHabilidato"></app-header>
<div class="div-chart-container" id="container">

    @if (false) {
    <div class="div-boton-vista div-2">
        @if (botonTabla) {
        <button class="boton-vista-datos boton-info-serie" id="vistaTabla" (click)="toggleView()">{{nombreBotonTabla}}
        </button>
        }

    </div>
    }
    <div class="cardContenido div-chart div-4">
        <div id="containerMercadoCambiario" style="width: 100%; height: 600px; display: block;" class="container-series-highcharts"></div>
    </div>
    <br>
    <div>
        <table *ngIf="isTablaMercadoCambiario">
            <thead>
                <th>Hora última actualización</th>
                <th>Última tasa (COP)</th>
                <th>Tasa promedio del mercado (COP)</th>
                <th>Tasa apertura (COP)</th>
                <th>Monto (millones de USD)</th>
            </thead>
            <tbody>
                <tr>
                    <td class="tabla-columna-mercado-cambiario hora">{{mercadoCambiario.hora}}</td>
                    <td class="tabla-columna-mercado-cambiario">{{mercadoCambiario.precioCierre}}</td>
                    <td class="tabla-columna-mercado-cambiario">{{mercadoCambiario.precioPromedio}}</td>
                    <td class="tabla-columna-mercado-cambiario">{{mercadoCambiario.precioApertura}}</td>
                    <td class="tabla-columna-mercado-cambiario">{{mercadoCambiario.montoTotal}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>